// import { enableProdMode } from "@angular/core";

export const environment = {
    production: true,
    api_base_url: 'https://otytuz6c6e.execute-api.eu-west-2.amazonaws.com/prod/',
    Audit: '78ebe264-9008-454d-9eda-62f3ce02bf48',
    Branch: 'c91662cb-0007-4a46-9584-5694dea9c111',
    Distribution: '3308788f-8f62-4fbf-90a8-0e7d98cc2998',
    Period: 'c29c87c0-8724-49ca-8944-e49758586fd1',
    Publisher: '4d10bcd3-9d2f-46dd-83ae-03cb9b061e2f',
    LeagueTable: '02736f1b-60e2-4ed6-a4d7-c622a3d83134',
    Region: '913646d1-1904-40f5-87ae-41a7ad35dfb1',
    Trend: '4cbf6ec8-e594-438c-8fc5-7396c02968a0',
    app_version: '1.0.8'
};

// enableProdMode();